import JobHistory from "../JobHistory/JobHistory";

const JobHistoryPage = () => {
  return (
    <div className="min-h-[100vh] bg-mine-shaft-950 font-['poppins'] px-4">
      <div className="my-5">
        <JobHistory />
      </div>
    </div>
  );
};
export default JobHistoryPage;
